// extracted by mini-css-extract-plugin
module.exports = {"figure":"FigureWithCaption_figure__tX5Wn","caption":"FigureWithCaption_caption__15Csp"};